export default [
    {
      path: '/admin/finance/exchange-rates',
      name: 'exchange-rate',
      meta: { requiresAuth: true },
      component: () => import('@/pages/finance/exchange-rate/index.vue')
    },
  ]
